import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=36fe10d3"
import script from "@/views/Curricula/Curriculum.ts?vue&type=script&lang=ts&external"
export * from "@/views/Curricula/Curriculum.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Curricula/Curriculum.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports